module.exports = __webpack_public_path__ + "static/4-945df35c3d77ef70fc1758ef30d9903d.jpg";